module.exports = __webpack_public_path__ + "static/media/linkedinLogo.dded5462.png";